import React from 'react'

const Pembuka = () => {
  return (
    <div className='mt-5'>Yang bertanda tangan di bawah ini, Ketua Rukun Tetangga (RT) 05 Rukun Warga (RW) 24 Kel. / Kec. Baleendah Kabupaten Bandung, dengan ini mengerangkan bahwa:</div>
  )
}

export default Pembuka